import { ENTORNO } from "../utils/constantes";
import {
  getIdioma,
  getLocalidad,
  getemail,
  setCodigoRecuperacion,
  setToken,
  setrole,
  setemail,
  setpassword,
  setNombre,
  setApellido,
  setTelefono,
  setIdentificacion,
  setLocalidad,
  setIdioma,
  setContactosEmergencia,
  setEstadoConductor,
  setavatar,
  setid,
  getpassword,
  getid,
  getToken,
  setusuarioPerfil,
} from "../utils/variablesLocales";

export class apiUsuario {
  baseApi = ENTORNO.BASE_API;

  async obtenerTodos() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Obtener}?active=true`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async obtenerTodosConFiltros(localidad, rol, nombre, apellido, email) {
    try {
      let url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Obtener}?active=true`;

      if (localidad !== "") url = url + `&Localidad=${localidad}`;
      if (rol !== "") url = url + `&role=${rol}`;
      if (nombre !== "") url = url + `&Nombre=${nombre}`;
      if (apellido !== "") url = url + `&Apellido=${apellido}`;
      if (email !== "") url = url + `&email=${email}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async obtener(Id) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Obtener}?_id=${Id}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async crearCuenta(Nombre, Apellido, Email, Telefono, Clave) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_CrearCuenta}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Nombre: Nombre,
          Apellido: Apellido,
          Idioma: getIdioma(),
          Localidad: getLocalidad(),
          email: Email,
          Telefono: Telefono,
          role: "Pasajero",
          active: false,
          password: Clave,
          avatar: "",
          CodigoActivacion: "",
          CodigoRecuperacionCantidadVeces: 0,
          CodigoRecuperacionBloqueado: false,
          CodigoRecuperacion: "",
          ContactosEmergencia: "",
          EmpresaId: "",
          FechaAlta: Date.now(),
          FechaUltimaModificacion: Date.now(),
          RequiereCambiarClave: false,
          Mobbex_IdUsuario: "",
          Mobbex_TokenTarjeta: "",
          Mobbex_TokenTarjetaTerminaEn: "",
          Mobbex_sourceId: "",
          Mobbex_CVV: "",
          Identificacion: "",
          TokenNotificacion: "",
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) {
        throw respuestaJson;
      }

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async reenviarCodigoActivacion() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_ReenviarCodigoActivacion}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: getemail(),
          Idioma: getIdioma(),
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) {
        throw respuestaJson;
      }

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async activarCuenta(CodigoActivacion) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_ActivarCuenta}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: getemail(),
          CodigoActivacion: CodigoActivacion,
          active: false,
          Idioma: getIdioma(),
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) {
        throw respuestaJson;
      }

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async validarEmail(Email) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_ValidarEmail}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: Email,
          Idioma: getIdioma(),
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();
      return respuestaJson.Estado;
    } catch (error) {
      throw error;
    }
  }

  async generarCodigoRecuperacion(Email) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_GenerarCodigoRecuperacion}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: Email,
          Idioma: getIdioma(),
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();
      setCodigoRecuperacion(respuestaJson.CodigoRecuperacion);

      return respuestaJson.Estado;
    } catch (error) {
      throw error;
    }
  }

  async validarCodigoRecuperacion(CodigoRecuperacion) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_ValidarCodigoRecuperacion}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: getemail(),
          CodigoRecuperacion: CodigoRecuperacion,
          Idioma: getIdioma(),
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuestaJson.Estado !== "Ok") {
        return respuestaJson.Mensaje;
      } else {
        return respuestaJson.Estado;
      }
    } catch (error) {
      throw error;
    }
  }

  async cambiarClave(Password) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_CambiarClave}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: getemail(),
          password: Password,
          Idioma: getIdioma(),
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuestaJson.Estado !== "Ok") {
        return respuestaJson.Mensaje;
      } else {
        return respuestaJson.Estado;
      }
    } catch (error) {
      throw error;
    }
  }

  async Ingresar(email, Password, Idioma) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Ingresar}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: Password,
          Idioma: Idioma,
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuestaJson.Estado !== "Ok") {
        return respuestaJson.Mensaje;
      } else {
        setToken(respuestaJson.access);
        setrole(respuestaJson.Usuario.role);
        setemail(respuestaJson.Usuario.email);
        setpassword(respuestaJson.Usuario.password);
        setid(respuestaJson.Usuario._id);
        setusuarioPerfil(respuestaJson.Usuario.role);
        setNombre(respuestaJson.Usuario.Nombre);
        setApellido(respuestaJson.Usuario.Apellido);
        setTelefono(respuestaJson.Usuario.Telefono);
        setIdentificacion(respuestaJson.Usuario.Identificacion);
        setLocalidad(respuestaJson.Usuario.Localidad);
        setIdioma(respuestaJson.Usuario.Idioma);
        setContactosEmergencia(respuestaJson.Usuario.ContactosEmergencia);
        setEstadoConductor(respuestaJson.Usuario.EstadoConductor);

        if (respuestaJson.Usuario.avatar !== "") {
          setavatar(
            ENTORNO.BASE_PATH +
              "/" +
              respuestaJson.Usuario.avatar.replace("uploads/", "")
          );
        } else {
          setavatar(ENTORNO.BASE_PATH + "/avatar/imagenNoDisponible.png");
        }

        return respuestaJson.Estado;
      }
    } catch (error) {
      throw error;
    }
  }

  async IngresarConPasswordEncriptado(email, Password, Idioma) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_IngresarConPasswordEncriptado}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: Password,
          Idioma: Idioma,
        }),
      };

      const respuesta = await fetch(url, parametros);

      const respuestaJson = await respuesta.json();

      if (respuestaJson.Estado !== "Ok") {
        return respuestaJson.Mensaje;
      } else {
        setToken(respuestaJson.access);
        setrole(respuestaJson.Usuario.role);
        setemail(respuestaJson.Usuario.email);
        setpassword(respuestaJson.Usuario.password);
        setid(respuestaJson.Usuario._id);
        setusuarioPerfil(respuestaJson.Usuario.role);
        setNombre(respuestaJson.Usuario.Nombre);
        setApellido(respuestaJson.Usuario.Apellido);
        setTelefono(respuestaJson.Usuario.Telefono);
        setIdentificacion(respuestaJson.Usuario.Identificacion);
        setLocalidad(respuestaJson.Usuario.Localidad);
        setIdioma(respuestaJson.Usuario.Idioma);
        setContactosEmergencia(respuestaJson.Usuario.ContactosEmergencia);
        setEstadoConductor(respuestaJson.Usuario.EstadoConductor);

        if (respuestaJson.Usuario.avatar !== "") {
          setavatar(
            ENTORNO.BASE_PATH +
              "/" +
              respuestaJson.Usuario.avatar.replace("uploads/", "")
          );
        } else {
          setavatar(ENTORNO.BASE_PATH + "/avatar/imagenNoDisponible.png");
        }

        return respuestaJson.Estado;
      }
    } catch (error) {
      throw error;
    }
  }

  async refrescarToken() {
    try {
      if (getIdioma() === null) {
        setIdioma("Español");
      }

      if (getemail() !== null) {
        if (getpassword() !== null) {
          const respuesta = await this.Ingresar(
            getemail(),
            getpassword(),
            getIdioma()
          );

          if (respuesta !== "Ok") {
            //navigateToIngresar();
          }
        }
      }
    } catch (error) {
      throw error;
    }
  }

  async actualizar(
    Nombre,
    Apellido,
    Idioma,
    Localidad,
    email,
    Telefono,
    Identificacion,
    avatar,
    ContactosEmergencia
  ) {
    try {
      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Usuario_Actualizar
      }/${getid()}`;

      const parametros = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          Nombre: Nombre,
          Apellido: Apellido,
          Idioma: Idioma,
          Localidad: Localidad,
          email: email,
          Telefono: Telefono,
          Identificacion: Identificacion,
          ContactosEmergencia: ContactosEmergencia,
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async actualizarAvatar(
    Nombre,
    Apellido,
    Idioma,
    email,
    Telefono,
    Identificacion,
    avatar
  ) {
    try {
      const formData = new FormData();
      formData.append("Nombre", Nombre);
      formData.append("Apellido", Apellido);
      formData.append("Idioma", Idioma);
      formData.append("Localidad", "");
      formData.append("email", email);
      formData.append("Telefono", Telefono);
      formData.append("Identificacion", Identificacion);
      formData.append("avatar", avatar);
      formData.append("ContactosEmergencia", "");

      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Usuario_ActualizarAvatar
      }/${getid()}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async actualizarIdentificacion(Identificacion) {
    try {
      const formData = new FormData();
      formData.append("Identificacion", Identificacion);

      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Usuario_ActualizarAvatar
      }/${getid()}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async actualizarTokenNotificacion(TokenNotificacion) {
    try {
      const formData = new FormData();
      formData.append("TokenNotificacion", TokenNotificacion);

      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Usuario_ActualizarAvatar
      }/${getid()}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async actualizarMobbex_IdUsuario(Mobbex_IdUsuario) {
    try {
      const formData = new FormData();
      formData.append("Mobbex_IdUsuario", Mobbex_IdUsuario);

      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Usuario_ActualizarAvatar
      }/${getid()}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async actualizarMobbex_TokenTarjeta(
    Mobbex_TokenTarjeta,
    Mobbex_TokenTarjetaTerminaEn
  ) {
    try {
      const formData = new FormData();
      formData.append("Mobbex_TokenTarjeta", Mobbex_TokenTarjeta);
      formData.append(
        "Mobbex_TokenTarjetaTerminaEn",
        Mobbex_TokenTarjetaTerminaEn
      );

      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Usuario_ActualizarAvatar
      }/${getid()}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async actualizarMobbex_sourceId(Mobbex_sourceId) {
    try {
      const formData = new FormData();
      formData.append("Mobbex_sourceId", Mobbex_sourceId);

      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Usuario_ActualizarAvatar
      }/${getid()}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async actualizarMobbex_CVV(Mobbex_CVV) {
    try {
      const formData = new FormData();
      formData.append("Mobbex_CVV", Mobbex_CVV);

      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Usuario_ActualizarAvatar
      }/${getid()}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async actualizarAvatarAdministrador(Nombre, Apellido, email, Telefono) {
    try {
      const formData = new FormData();
      formData.append("Nombre", Nombre);
      formData.append("Apellido", Apellido);
      formData.append("email", email);
      formData.append("Telefono", Telefono);

      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Usuario_ActualizarAvatar
      }/${getid()}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async actualizarAvatarConductor(
    Nombre,
    Apellido,
    Idioma,
    Localidad,
    email,
    Telefono,
    nombreBanco,
    titular,
    CBU
  ) {
    try {
      const formData = new FormData();
      formData.append("Nombre", Nombre);
      formData.append("Apellido", Apellido);
      formData.append("Idioma", Idioma);
      formData.append("Localidad", Localidad);
      formData.append("email", email);
      formData.append("Telefono", Telefono);
      formData.append("Banco_Nombre", nombreBanco);
      formData.append("Banco_Titular", titular);
      formData.append("Banco_CBU", CBU);

      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Usuario_ActualizarAvatar
      }/${getid()}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async nominaImportar(Archivo, EmpresaId) {
    try {
      const formData = new FormData();
      formData.append("Archivo", Archivo);
      formData.append("EmpresaId", EmpresaId);

      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Usuario_Importar}`;

      const parametros = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async activarConductor() {
    try {
      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Conductor_Activar
      }/${getid()}`;

      const parametros = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          EstadoConductor: "Activo",
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async inactivarConductor() {
    try {
      const url = `${this.baseApi}/${
        ENTORNO.API_ROUTES.Conductor_Activar
      }/${getid()}`;

      const parametros = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          EstadoConductor: "Inactivo",
          Viaje_IdViaje: "",
          Viaje_Pasajero: "Disponible",
          Viaje_Estado: "",
          Viaje_Partida: "",
          Viaje_Destino: "",
          Viaje_Min: "",
          Viaje_Kms: "",
          Viaje_PrecioBase: 0,
          Viaje_PrecioSugerido: 0,
          Viaje_VerEnGoogleMaps: "",
          Viaje_PartidaLatitud: "",
          Viaje_PartidaLongitud: "",
          Viaje_UbicacionVehiculoLatitud: "",
          Viaje_UbicacionVehiculoLongitud: "",
          Viaje_MinLlegadaABuscarPasajero: "",
          Viaje_VerEnGoogleMapsRutaBusquedaPasajero: "",
          Viaje_UbicacionAlBuscarPasajeroLatitud: "",
          Viaje_UbicacionAlBuscarPasajeroLongitud: "",
          Viaje_MetrosDistanciaEntreVehiculoYPasajero: 0,
          Viaje_PartidaLocalidad: "",
          Viaje_PartidaProvincia: "",
          Viaje_DestinoLatitud: "",
          Viaje_DestinoLongitud: "",
          Viaje_Saldo: 0,
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }
}
